const SET_NAVIGATION = 'myhealth/SET_NAVIGATION';

export {
    SET_NAVIGATION
};